@if (loadingData) {
  <app-loading-spinner />
} @else {
  <app-wizard
    [wizardType]="WizardType.EWE_BY_EMAIL"
    [customerWizardResponse]="customerWizardResponse"
    [brand]="brand"
    [legalEntity]="legalEntity"
    (stepAccepted)="onStepAccepted($event)"
    (stepSkipped)="onStepSkipped($event)"
  />
}
